<template>
  <div class="searchbar">
    <div>
      <ul class="status-filter"
        v-if="filters.status">
        <li>
          <label>Statut client</label>
          <div class="form-group form-group-default form-group-default-select2 selection-class">
            <slot name="status"></slot>
          </div>
        </li>
      </ul>
      <ul class="with-contract-filter"
          v-if="filters.withContract">
        <li>
          <label>Avec contrats ?</label>
          <div class="form-group form-group-default form-group-default-select2 selection-class">
            <slot name="with_contract"></slot>
          </div>
        </li>
      </ul>
      <ul class="distribution-methods-filter"
          v-if="filters.distributionMethods">
        <li>
          <label>Types de contrats</label>
          <div class="form-group form-group-default form-group-default-select2 selection-class">
            <slot name="distribution_methods"></slot>
          </div>
        </li>
      </ul>
      <ul class="agencies-filter"
        v-if="filters.agencies">
        <li>
          <label>Agences</label>
          <div class="form-group form-group-default form-group-default-select2 selection-class">
            <slot name="agencies"></slot>
          </div>
        </li>
      </ul>
      <ul class="distribution-methods-filter"
          v-if="filters.rbeStatus">
        <li>
          <label>Statut RBE</label>
          <div class="form-group form-group-default form-group-default-select2 selection-class">
            <slot name="rbe_status"></slot>
          </div>
        </li>
      </ul>
      <ul class="contract-instructions-filters"
          v-if="filters.contractInstructions">
        <li>
          <label>Colis</label>
          <div class="form-group form-group-default form-group-default-select2 selection-class">
            <slot name="package"></slot>
          </div>
        </li>
        <li>
          <label>Procuration</label>
          <div class="form-group form-group-default form-group-default-select2 selection-class">
            <slot name="postal"></slot>
          </div>
        </li>
        <li>
          <label>Courrier bloqué</label>
          <div class="form-group form-group-default form-group-default-select2 selection-class">
            <slot name="mail_blocked"></slot>
          </div>
        </li>
        <li>
          <label>Courrier réexpédié</label>
          <div class="form-group form-group-default form-group-default-select2 selection-class">
            <slot name="mail_forwarded"></slot>
          </div>
        </li>
      </ul>
      <ul class="contract-instructions-filters"
          v-if="filters.sapPromoCode">
        <li>
          <label>Code promo utilisé</label>
          <div class="form-group form-group-default form-group-default-select2 selection-class">
            <slot name="sap_promo_code"></slot>
          </div>
        </li>
      </ul>
    </div>
    <div style="max-width: 200px; justify-content: flex-end;">
      <slot name="export_button"></slot>

      <router-link v-if="addBtn"
                  tag="button"
                  class="btn btn-complete btn-cons"
                  style="margin-bottom: 20px;"
                  :to="{ name: 'create-prospects' }">
        Ajouter un prospect
      </router-link>
    </div>
  </div>
</template>


<script>
  export default {
    props: {
      filters: {
        type: Object,
        default() {
          return {
            agencies: true,
            distributionMethods: true,
            status: true,
            contractInstructions: true,
            withContract: true,
            rbeStatus: true,
            sapPromoCode: true
          }
        },
        validator(val) {
          const keys = _.keys(val),
            neededKeys = [
              "agencies",
              "distributionMethods",
              "status",
              "contractInstructions",
            ]
          return _.some(_.intersection(neededKeys, keys))
        },
      },
      addBtn: {
        type: Boolean,
        default: true,
      }
    },

    mounted() {
      setTimeout(() => {
        $(".dropdown-multiselect").select2()
        $(".dropdown-select").select2({
          minimumResultsForSearch: -1,
        })
      }, 200)
    }
  }
</script>

<style lang="scss" scoped>
  .searchbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
    padding-top: 10px;
    div {
      display: flex;
      flex-wrap: wrap;
      ul {
        padding: 0;
        margin: 0;
        display: flex;
        align-items: center;
        li {
          display: inline-block;
          list-style-type: none;
          margin-right: 5px;
        }
      }
    }
    .selection-class {
      min-width: 100px;
    }
  }

  // /* Prospects list specific */
  // .prospects-list .searchbar {
  //   .status-filter,
  //   .contract-instructions-filters {
  //     display: none;
  //   }
  // }
</style>



// WEBPACK FOOTER //
// client/components/CustomersList/SearchBar.vue